export default __webpack_public_path__ + "static/media/Estação Bicicleta.257f290a.svg";